import { Link, useNavigate } from "react-router-dom"
import classNames from "classnames"

import ErrorLayout from "modules/layout/error"
import Logo from "components/logo"

import { ReactComponent as AmalyetConfigurationIcon } from "assets/icons/amalyet-configuration.svg"
import { ReactComponent as AmalyetSuiteIcon } from "assets/icons/amalyet-suite.svg"
import { ReactComponent as UserProfileIcon } from "assets/icons/profile.svg"
import { ReactComponent as ArrowRightIcon } from "assets/icons/arrow-right.svg"
import { ReactComponent as ArrowLinkIcon } from "assets/icons/arrow-link.svg"

import styles from "../404/styles.module.scss"
import { useTranslation } from "react-i18next"

const PopularModule: React.FC<{
  icon: React.ReactNode
  title: string
  subtitle: string
}> = ({ icon, title, subtitle }) => (
  <div className={styles.module}>
    <div className={styles.icon}>{icon}</div>
    <div className={styles.infos}>
      <h5 className={classNames(styles.title, "body-heavy")}>{title}</h5>
      <p className={classNames(styles.subtitle, "caption")}>{subtitle}</p>
    </div>
    <ArrowRightIcon className={styles.arrowIcon} />
  </div>
)

const PermissionError: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const onNavigate = (link: string) => {
    navigate(link)
  }
  return (
    <ErrorLayout>
      <div>
        <ErrorLayout.Icon>
          <Logo />
        </ErrorLayout.Icon>
        <ErrorLayout.Error>{t("403.title")}</ErrorLayout.Error>
        <ErrorLayout.Title>{t("403.sub_title")}</ErrorLayout.Title>
        <ErrorLayout.Subtitle>{t("403.message")}</ErrorLayout.Subtitle>

        <div className={styles.popular}>
          <h5 className={classNames(styles.popularPages, "caption-heavy")}>
            {t("403.popular_pages")}
          </h5>
          <div className={styles.separator} />
          <Link
            to="/user/profile"
            className={styles.module}
            onClick={() => onNavigate("/user/profile")}
          >
            <PopularModule
              title="Profile"
              subtitle={t("errorPage.profile_subtitle")}
              icon={<UserProfileIcon className="subheader" />}
            />
          </Link>

          <div className={styles.separator} />
          <Link
            to="/configuration"
            className={styles.module}
            onClick={() => onNavigate("/configuration")}
          >
            <PopularModule
              title="Configuration"
              subtitle={t("services.configuration.subtitle")}
              icon={<AmalyetConfigurationIcon className="subheader" />}
            />
          </Link>
          <div className={styles.separator} />

          <Link
            to="/a-suite"
            className={styles.module}
            onClick={() => onNavigate("/user/profile")}
          >
            <PopularModule
              title="Suite"
              subtitle={t("services.a-suite.subtitle")}
              icon={<AmalyetSuiteIcon className="subheader" />}
            />
          </Link>
          <div className={styles.separator} />

          <Link
            to="/"
            className={classNames("body-heavy", styles.goHome)}
            onClick={() => onNavigate("/")}
          >
            <span>{t("403.go_home")}</span>
            <ArrowLinkIcon className="small" />
          </Link>
        </div>
      </div>
    </ErrorLayout>
  )
}

export default PermissionError
